import baseUrl from "../utils/baseUrl";
import axios from "./api";

const BASE = `${baseUrl}/mechanic-notification`;

const getNotificationsByMechanicId = async (mechanicId) =>
    axios.get(`${BASE}/${mechanicId}`).then((r) => r.data);

const sendNotification = async (body) =>
    axios.post(`${BASE}/send`, body).then((r) => r.data);

const deleteNotification = async (id) =>
    axios.delete(`${BASE}/${id}`);

const removeAllNotifications = async () =>
    axios.delete(`${BASE}/remove`).then((r) => r.data);

export {
    getNotificationsByMechanicId,
    sendNotification,
    deleteNotification,
    removeAllNotifications,
};
